import useApi from '@core/api/hooks/useApi';
import { GET_ALL_PERMISSIONS } from '@core/constants/endpoints';

export type Permission = {
  _id: string;
  key: string;
  label: string;
  module: string;
  description?: string;
};

export type GetAllPermissionsResponse = {
  status: number;
  result: {
    permissions: Permission[];
  };
};

/**
 * Hook to fetch all available permissions from the backend
 * Uses react-query for caching and automatic refetching
 */
export const useGetAllPermissions = (enabled = true) => {
  return useApi(
    { url: GET_ALL_PERMISSIONS() },
    {
      enabled,
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    }
  );
};
